/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatchedAnswer
 */
export interface PatchedAnswer {
    /**
     * 
     * @type {number}
     * @memberof PatchedAnswer
     */
    readonly id?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchedAnswer
     */
    question?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedAnswer
     */
    response?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedAnswer
     */
    readonly elementScore?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedAnswer
     */
    readonly globalScore?: string;
}

/**
 * Check if a given object implements the PatchedAnswer interface.
 */
export function instanceOfPatchedAnswer(value: object): value is PatchedAnswer {
    return true;
}

export function PatchedAnswerFromJSON(json: any): PatchedAnswer {
    return PatchedAnswerFromJSONTyped(json, false);
}

export function PatchedAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedAnswer {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'question': json['question'] == null ? undefined : json['question'],
        'response': json['response'] == null ? undefined : json['response'],
        'elementScore': json['element_score'] == null ? undefined : json['element_score'],
        'globalScore': json['global_score'] == null ? undefined : json['global_score'],
    };
}

  export function PatchedAnswerToJSON(json: any): PatchedAnswer {
      return PatchedAnswerToJSONTyped(json, false);
  }

  export function PatchedAnswerToJSONTyped(value?: Omit<PatchedAnswer, 'id'|'element_score'|'global_score'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'question': value['question'],
        'response': value['response'],
    };
}

